/** @format */

import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
    // margin: theme.spacing(1),
    minWidth: 120,
    '& .MuiInput-underline:before': {
      borderWidth: '2px',
      borderColor: 'black'
    },
    '& .MuiInput-underline.Mui-error:before': {
      borderWidth: '2px',
      borderColor: '#f44336'
    },
    '& > label': {
      fontSize: 18,
      color: 'black'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'black'
    }
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  select: {
    color: '#000',
    textAlign: 'left',
    fontSize: 18,
    '&:after': {
      position: 'absolute',
      top: '50%',
      right: 0,
      left: 'auto',
      bottom: 'auto',
      transform: 'translate(0, -50%)!important',
      width: 16,
      height: 16,
      background: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12.7715 18.0647C12.3715 18.5496 11.6285 18.5496 11.2285 18.0647L4.68933 10.1363C4.15137 9.48404 4.61532 8.5 5.46079 8.5L18.5392 8.5C19.3847 8.5 19.8486 9.48405 19.3107 10.1363L12.7715 18.0647Z" fill="%23868686"/></svg>') center center no-repeat`,
      backgroundSize: '16px 16px',
      border: 0,
      borderRadius: 100
    }
  }
}));

const SelectComponent = props => {
  const classes = useStyles();
  const [value, setValue] = React.useState(props.value || '');

  const handleChange = event => {
    if (props.onChange) {
      props.onChange(event);
    }
  };

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  return (
    <>
      <FormControl className={classes.formControl} error={props.error}>
        <InputLabel>{props?.label}</InputLabel>
        <Select error={props.error} className={classes.select} value={props.value || value} onChange={handleChange}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {props?.options?.map(item => (
            <MenuItem value={item?.value || item?.name} key={item?.value || item?.name}>
              {item?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default SelectComponent;
